import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { deleteIcon, grayViewIcon, HideIcon, tableEditIcon } from "../../../assets/images";
import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import { AuditSessionListType } from "../../../redux/fixedAsset/fixedAssetRegisterTypes";
import UpdatedByAndUpdatedAt from "../../commons/CommonUpdatedByAndUpdatedAt";
import {
  formateDateWithTime,
} from "../../../utils/commonFunctions";
import {  useParams } from "react-router-dom";
type AppProps = {
  tableHeaders: TableHeadersType[] | [];
  data: AuditSessionListType[] | [];
  history: any;
  type:string;
  handleDelete?: (id: string) => void;
  isSOPEditPresent?: boolean;
  isSOPDeletePresent?: boolean;
  handleHideSop?:(data:any)=>void;
  handleUnHideSop?:(data:any)=>void;
  hideSOPPresent?:boolean;
};
const SopModuleTableData = ({
  tableHeaders,
  data,
  type,
  history,
  handleDelete,
  isSOPEditPresent,
  isSOPDeletePresent,
  handleUnHideSop,
  handleHideSop,
  hideSOPPresent
}: AppProps) => {
  const { id }: any = useParams();
  const client_code = history?.location?.state?.client_code
    ? history?.location?.state?.client_code
    : id;

  const company_name =
    history &&
    history.location &&
    history.location.state &&
    history.location.state.company_name
      ? history.location.state.company_name
      : "";

  const handleRedirection=(sopData:any)=>{
    history.push({pathname:`/sops/${sopData?.sop_id}/edit/${sopData?.client_code}`,state:{sop_id:sopData?.sop_id,client_code:sopData?.client_code, company_name:sopData?.client_name, type:"adminReport"}})
  }
  return (
    <>
      {data?.length > 0 &&
        data?.map((sopData: any) => {
          return (
            <tr className="text-left" 
            style={{ backgroundColor: sopData?.is_hidden && type==="sop" ? "#f4f6f8" : "" }}
            >
              {tableHeaders?.length > 0 &&
                tableHeaders?.map((header: TableHeadersType) => {
                  if (header?.value == "file_name") {
                    return <td className="text-left">{type!=="adminReport" ? sopData?.file_name : <div className="pointer" style={{borderBottom:"1px solid black", width:"fit-content"}} onClick={()=>handleRedirection(sopData)}>{sopData?.file_name}</div>} </td>;
                  }
                  else if(header?.value == "client_name"){
                    return <td>{sopData?.client_name} ({sopData?.client_code})</td>
                  }
                  else if (header?.value === "updated_by") {
                    return (
                      <td className="text-start" style={{ minWidth: "180px" }}>
                        <UpdatedByAndUpdatedAt
                          firstName={sopData?.updated_by?.first_name}
                          lastName={sopData?.updated_by?.last_name}
                          profilePic={
                            sopData?.updated_by?.profile_pic
                              ? sopData?.updated_by?.profile_pic?.file_url
                              : ""
                          }
                          updatedAt={formateDateWithTime(sopData?.updated_at)}
                        />
                      </td>
                    );
                  } else if (header?.value == "action") {
                    return (
                      <td style={{ width: "50px", textAlign: "start" }}>
                        {isSOPEditPresent && (
                          <span
                            className="d-inline-block pointer"
                            onClick={() => {
                              history?.push({
                                pathname: `/sops/${client_code}/edit/${sopData?.sop_id}`,
                                state: {
                                  client_code,
                                  company_name,
                                  sop_id: sopData?.sop_id,
                                },
                              });
                            }}
                          >
                            <div
                              style={{
                                color: "#d43",
                                fontSize: 20,
                              }}
                            >
                              <OverlayTrigger
                                placement="top"
                                delay={{ show: 250, hide: 250 }}
                                overlay={
                                  <Tooltip id="button-view-open-item">
                                    Edit
                                  </Tooltip>
                                }
                              >
                                <img src={tableEditIcon} alt="" />
                              </OverlayTrigger>
                            </div>
                          </span>
                        )}
                        {isSOPDeletePresent && (
                          <span className="d-inline-block pointer">
                            <div
                              style={{
                                color: "#d43",
                                fontSize: 20,
                                width: "30px",
                              }}
                            >
                              <OverlayTrigger
                                placement="top"
                                delay={{ show: 250, hide: 250 }}
                                overlay={
                                  <Tooltip id="button-view-open-item">
                                    Delete
                                  </Tooltip>
                                }
                              >
                                <img
                                  onClick={() =>
                                    handleDelete?.(sopData?.sop_id)
                                  }
                                  src={deleteIcon}
                                  alt="Delete"
                                />
                              </OverlayTrigger>
                            </div>
                          </span>
                        )}
                        {hideSOPPresent && (
                          <OverlayTrigger
                          placement="top"
                          delay={{ show: 250, hide: 250 }}
                          overlay={
                            <Tooltip id="button-view-open-item">
                              <div className="d-flex flex-column">
                                <span
                                  style={{
                                    fontSize: "13px",
                                    color: "#ffffff",
                                    fontWeight: "600",
                                  }}
                                >
                                  {sopData?.is_hidden
                                    ? "SOP is Hidden."
                                    : "SOP is Visible."}
                                </span>
                                <span
                                  style={{
                                    fontSize: "12px",
                                    color: "#ffffff",
                                    fontWeight: "normal",
                                  }}
                                >
                                  {sopData?.is_hidden
                                    ? "Click on button to show sop."
                                    : "Click on button to hide sop."}
                                </span>
                              </div>
                            </Tooltip>
                          }
                        >
                          <span
                         className="pointer"

                            style={{
                              border: "1px solid #bfcbe1",
                              padding: "6px 8px",
                              borderRadius: "5px",
                              width: "125px",
                              justifyContent: "center",
                            }}
                            onClick={() =>
                              {
                                if (sopData?.is_hidden===1) {
                                  handleUnHideSop?.(
                                    sopData
                                  );
                                } else if(sopData?.is_hidden===0) {
                                  handleHideSop?.(sopData);
                                }
                              }
                            }
                          >
                            <img
                              src={
                                sopData?.is_hidden
                                  ? grayViewIcon
                                  : HideIcon
                              }
                              alt="hide"
                            />
                            <span
                              style={{
                                color: "#6e7491",
                                fontSize: "12px",
                                fontWeight: "500",
                                marginBottom: "-5px",
                                marginLeft: "9px",
                              }}
                            >
                              {sopData?.is_hidden
                                ? "Show SOP"
                                : "Hide SOP"}
                            </span>
                          </span>
                        </OverlayTrigger>
                        )}
                      </td>
                    );
                  }
                  return null;
                })}
            </tr>
          );
        })}
    </>
  );
};

export default SopModuleTableData;
